import React, { useRef, useState } from "react";
import Minus from "images/icons/minus.inline.svg";
import Plus from "images/icons/plus.inline.svg";

const ParticipantsFC = ({
  gviTrainingTitle,
  gviTrainingDetails,
  title,
  content
}) => {
  const [isOpened, setOpened] = useState(false);
  const [height, setHeight] = useState("0px");
  const contentElement = useRef(null);

  const handleAccordion = () => {
    setOpened(!isOpened);
    setHeight(!isOpened ? `${contentElement.current.scrollHeight}px` : "0px");
  };
  return (
    <div>
      <div>
        <div
          className={"flex justify-between text-white items-center cursor-auto"}
          onClick={handleAccordion}
        >
          <h6 className="!py-3 w-3/4 md:11/12 planet:text-white">
            {gviTrainingTitle ? gviTrainingTitle : title}
          </h6>
          <div className="shrink-0">
            {isOpened ? (
              <Minus className="fill-black-lighter planet:fill-white" />
            ) : (
              <Plus className="fill-black-lighter planet:fill-white" />
            )}
          </div>
        </div>

        <div
          ref={contentElement}
          style={{ height: height }}
          className="overflow-hidden transition-all duration-200"
        >
          <div className="w-full h-0 my-3 border-b planet:border-gray-light" />
          <h6
            className="planet:!text-gray-lighter"
            dangerouslySetInnerHTML={{
              __html: gviTrainingDetails ? gviTrainingDetails : content
            }}
          />
        </div>
      </div>
    </div>
  );
};

const Training = ({
  programTrainingTitle,
  trainingIntroductionText,
  gviTrainingList,
  hubTrainings,
  hubName
}) => {
  return (
    <>
      <h2 className="heading py-5 text-left text-[26px] md:text-[2rem]">
        {programTrainingTitle}
      </h2>
      <div className="divide-y width-divider" />

      <div
        className="pt-6 planet:gvi-light-gray-text text-black-lighter tab-content_html"
        dangerouslySetInnerHTML={{ __html: trainingIntroductionText }}
      />

      {hubTrainings && hubTrainings.length > 0 && (
        <h3 className="!pt-8">For all GVI participants</h3>
      )}
      {gviTrainingList?.map((accordion, index) => (
        <ParticipantsFC {...accordion} key={index} />
      ))}

      {hubTrainings && hubTrainings.length > 0 && (
        <h3 className="!pt-8">For all participants at {hubName}</h3>
      )}
      {hubTrainings?.map((accordion, index) => (
        <ParticipantsFC {...accordion} key={index} />
      ))}
    </>
  );
};

export default Training;
